import React, { Component } from 'react';
import Truncate from 'react-truncate';
import classes from './ListItem.module.css';
import genderAvatarOne from '../../../assets/images/avatar/user-placeholder-gender-one.png';
import genderAvatarTwo from '../../../assets/images/avatar/user-placeholder-gender-two.png';
import genderAvatarThree from '../../../assets/images/avatar/user-placeholder-gender-three.png';
import config from '../../../constants/config';
import {
  getAge,
  getChatDateFormat,
  getMaxDate,
} from '../../../assets/helpers/dateTimeUtils';
import strings from '../../../assets/localization';
import BadgeDot from '../BadgeDot/BadgeDot';
import LazyImage from '../LazyImage/LazyImage';

const deepEqual = require('deepequal');

export default class ListItem extends Component {
  shouldComponentUpdate(nextProps) {
    if (deepEqual(nextProps.user, this.props.user)) {
      return false;
    }
    return true;
  }

  render() {
    // console.log('ListITEM RENDER:', this.props);
    const { user, currentUser, listItemStyle, showViews, goToMemberProfile } =
      this.props;

    let location;
    const {
      images,
      username,
      first_name,
      dob,
      city,
      state,
      country,
      sex,
      fromChat,
      received_last,
      sent_last,
      unseen,
      unopened,
      online,
      tag_line,
      virtual_chat,
      admin_subtitle,
      user_id,
    } = user;
    const chatDateStr = fromChat
      ? getChatDateFormat(getMaxDate(received_last, sent_last))
      : '';

    let userImage;

    if (images && images.length > 0) {
      if (typeof images[0] === 'object' && images[0].hasOwnProperty('url')) {
        userImage = images[0].url;
      } else if (
        typeof images[0] === 'object' &&
        images[0].hasOwnProperty('thumb')
      ) {
        userImage = images[0].thumb;
      } else {
        userImage = images[0];
      }
    } else if (sex === config.GENDER_ONE) {
      userImage = genderAvatarOne;
    } else if (sex === config.GENDER_TWO) {
      userImage = genderAvatarTwo;
    } else {
      userImage = genderAvatarThree;
    }

    if (currentUser.country === 'US' && country === 'US') {
      location = `${city}, ${state}`;
    } else {
      location = `${city}, ${country}`;
    }

    // const photoCount = images && images.length > 0 ? images.length : 0;
    let photoCount = 0;

    for (let i = 0; i < images.length; i++) {
      if (!images[i].placeholder) {
        photoCount++;
      }
    }

    let liNameAndAgeCss = fromChat
      ? [classes.ListItemNameAndAge, classes.ListItemNameAndAgeChat].join(' ')
      : classes.ListItemNameAndAge;
    let liNameAndAgeAllCss = unopened
      ? [liNameAndAgeCss, classes.ListItemNameAndAgeUnopened].join(' ')
      : liNameAndAgeCss;
    let renderAge = !virtual_chat ? (
      <span>&nbsp;|&nbsp;{getAge(dob)}</span>
    ) : null;
    return (
      <div className={classes.ListItem} style={listItemStyle}>
        <div
          className={classes.ListItemLeft}
          onClick={(e) => {
            if (
              goToMemberProfile &&
              user_id !== 'Admin' &&
              user_id !== 'Admin2'
            ) {
              // console.log('KLIKK!!!!!');
              e.preventDefault();
              goToMemberProfile(user_id);
            }
          }}
        >
          <div className={classes.ListItemImageWrapper}>
            {virtual_chat ? (
              <div
                className={classes.ListItemImageSystem}
                style={{
                  borderColor: this.props.user.vip_user ? '#FFA42D' : null,
                }}
              >
                <svg className={classes.IconSvg}>
                  <use xlinkHref='#icon-logo-tiny' />
                </svg>
              </div>
            ) : (
              <div
                className={classes.ListItemImage}
                style={{
                  borderColor: this.props.user.vip_user ? '#FFA42D' : null,
                }}
              >
                <LazyImage
                  sex={sex}
                  srcLoaded={userImage}
                  style={{ borderRadius: '50%' }}
                  lazyImgStyle={{ objectFit: 'cover' }}
                  notLazy={this.props.notLazy}
                />
              </div>
            )}
            {photoCount > 0 && !fromChat ? (
              <div className={classes.ListItemCameraWrapper}>
                <svg className={classes.ListItemCameraCount}>
                  <use xlinkHref='/sprites.svg#icon-camera-filled' />
                </svg>
                <span className={classes.ListItemCameraCountNumber}>
                  {photoCount}
                </span>
              </div>
            ) : null}
            <div className={classes.ListItemBadgePosition}>
              <BadgeDot active={online} />
            </div>
            {this.props.user.vip_user ? (
              <div
                className={classes.ListItemVipBadgeWrapper}
                style={{
                  backgroundColor: online
                    ? 'var(--online-badge-background)'
                    : 'var(--vip-border-color)',
                }}
              >
                <svg className={classes.ListItemVipBadge}>
                  <use xlinkHref='/sprites.svg#vip-member-badge' />
                </svg>
              </div>
            ) : null}
          </div>
        </div>
        <div className={classes.ListItemRight}>
          <div className={classes.ListItemRightData}>
            <span className={liNameAndAgeAllCss}>
              <span className={classes.ListItemBadgeRedPosition}>
                <BadgeDot small active={unseen} />
              </span>
              <Truncate lines={1} ellipsis='...'>
                {first_name || username}
              </Truncate>
              {renderAge}
            </span>
            <span className={classes.ListItemLocation}>
              {!virtual_chat ? (
                <Truncate lines={1} ellipsis='...'>
                  {location}
                </Truncate>
              ) : (
                admin_subtitle || config.TITLE
              )}
            </span>
            <div className={classes.TagAndBadge}>
              {showViews && user.cnt ? (
                <span className={classes.ListItemViewedCountTag}>
                  {user.cnt}&nbsp;
                  {user.cnt === 1 ? strings.view : strings.views}
                </span>
              ) : null}
              <span className={classes.ListItemTagLine}>
                <Truncate lines={1} ellipsis='...'>
                  {tag_line}
                </Truncate>
              </span>
            </div>
          </div>
          {fromChat ? (
            <span className={classes.ListItemDate}>{chatDateStr}</span>
          ) : null}
          <svg
            className={classes.ListItemRightArrow}
            style={{ marginTop: fromChat ? '1.25rem' : '0' }}
          >
            <use xlinkHref='/sprites.svg#icon-arrow-right' />
          </svg>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/ListItem/ListItem.js